import { useDeviceType } from '@cian/ui-kit';

import { Step, type TFirstStepBackground } from 'shared/components/Step';
import { useCarousel } from 'shared/hooks';
import { TBannerType } from 'shared/types/banner';
import type { TStepAccent } from 'shared/utils/steps';

import { shouldShowCarouselArrows } from 'shared/utils/carousel';

interface IStepContainerProps {
  step: number;
  title: string;
  slides: React.ReactNode;
  slidesCount: number;
  mainTitle: string;
  firstBackground: TFirstStepBackground;
  isMainTitleOutside: boolean;
  isFirst: boolean;
  banner?: TBannerType;
  stepAccent?: TStepAccent;
}

export const StepContainer: React.FC<IStepContainerProps> = ({
  step,
  title,
  slides,
  slidesCount,
  mainTitle,
  firstBackground,
  isMainTitleOutside,
  isFirst,
  banner,
  stepAccent,
}) => {
  const device = useDeviceType();
  const { emblaRef, scrollPrev, scrollNext, canScrollPrev, canScrollNext } = useCarousel(device, slidesCount);
  const showArrows = shouldShowCarouselArrows(slidesCount, device);
  const showMainTitle = isFirst && Boolean(mainTitle);

  return (
    <Step
      step={step}
      title={title}
      slides={slides}
      device={device}
      mainTitle={mainTitle}
      firstBackground={firstBackground}
      isMainTitleOutside={isMainTitleOutside}
      isFirst={isFirst}
      banner={banner}
      stepAccent={stepAccent}
      emblaRef={emblaRef}
      scrollPrev={scrollPrev}
      scrollNext={scrollNext}
      canScrollPrev={canScrollPrev}
      canScrollNext={canScrollNext}
      showArrows={showArrows}
      showMainTitle={showMainTitle}
    />
  );
};
